export default {
  init() {
    // JavaScript to be fired on the home page

    $('.home-banner .slides').slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $('#best-options').click(function(e){
      e.preventDefault();
      location.href = $('#category-select').val();
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js